/**
 * Created by orenm on 12/10/2014.
 */
define(function (require) {
    "use strict";
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");



    var ArticleModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        ArticleModel = BaseModel.extend({
            defaults: {
            },
            resource: _.clone(ApiResources.ConnectionPanel.Article),
            name: "ArticleModel",
            initialize: function (options) {
                this.options = options;
                var isAuthenticated = LE.sessionManager.isAuthenticated();
                this.originalUrl = isAuthenticated ? this.resource.securedUrl : this.resource.url;
                this._initializeResource(this.options);
            },

            _initializeResource: function (options) {
                var slug = options.slug;
                var lang = options.lang;

                // TODO validate
                this.resource.url = this.originalUrl;
                this.resource.url = this.resource.url.replace("{slug}", slug);
                this.resource.url = this.resource.url.replace("{lang}", lang);
            }

        });
    });
    return ArticleModel;
});
